<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="invoice-page">

        <div class="flex flex-wrap items-center justify-between">
          <vx-input-group class="mb-base mr-3">
          </vx-input-group>
          <div class="flex items-center">
            <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="printInvoice">IMPRIMIR</vs-button>
          </div>
        </div>

        <vx-card id="invoice-container">

            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <div class="vx-col w-1/2 mt-base">
                    <img src="@/assets/images/logo/logo.png" alt="vuexy-logo">
                </div>
                <div class="vx-col w-1/2 text-right">
                    <h1>PEDIDO</h1>
                    <div class="invoice__invoice-detail mt-6">
                        <h6>PEDIDO NO.</h6>
                        <p>{{ invoiceDetails.invoiceNo }}</p>

                        <h6 class="mt-4">FECHA</h6>
                        <p>{{ invoiceDetails.invoiceDate  }}</p>
                    </div>
                </div>
                <div class="vx-col w-1/2 mt-12">
                    <h5>CLIENTE</h5>
                    <div class="invoice__recipient-info my-4">
                        <p>{{ recipientDetails.fullName }}</p>
                        <p>{{ recipientDetails.rucced }}</p>
                        <p>{{ recipientDetails.addressLine1 }}</p>
                        <p>{{ recipientDetails.mailId }}</p>
                    </div>
                </div>

            </div>

            <!-- INVOICE CONTENT -->
            <div class="p-base">
                <!-- INVOICE TASKS TABLE -->
                <vs-table hoverFlat :data="invoiceData.tasks">
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th class="pointer-events-none">CODIGO</vs-th>
                        <vs-th class="pointer-events-none">NOMBRE</vs-th>
                        <vs-th class="pointer-events-none">CANTIDAD</vs-th>
                        <vs-th class="pointer-events-none">P.UNITARIO</vs-th>
                        <vs-th class="pointer-events-none">DESCUENTO</vs-th>
                        <vs-th class="pointer-events-none">TOTAL</vs-th>
                    </template>

                    <!-- DATA -->
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td :data="data[index].codart">{{ data[index].codart }}</vs-td>
                            <vs-td :data="data[index].nomart">{{ data[index].nomart }}</vs-td>
                            <vs-td :data="data[index].cantid">{{ data[index].cantid }}</vs-td>
                            <vs-td :data="data[index].preuni">{{ data[index].preuni.toFixed(2) }}</vs-td>
                            <vs-td :data="data[index].desren">{{ data[index].desren.toFixed(2) }}</vs-td>
                            <vs-td :data="data[index].totren">{{ data[index].totren.toFixed(2) }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>

                <!-- INVOICE SUMMARY TABLE -->
                <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="invoiceData">
                    <vs-tr>
                        <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
                        <vs-td>{{ invoiceData.subtotal.toFixed(2) }} </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">TOTAL NETO</vs-th>
                        <vs-td>{{ invoiceData.totalneto.toFixed(2) }} </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">DESCUENTO</vs-th>
                        <vs-td>{{ invoiceData.descuento.toFixed(2) }} </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">Graba IVA</vs-th>
                        <vs-td>{{ invoiceData.grabaiva.toFixed(2) }} </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">No Graba IVA</vs-th>
                        <vs-td>{{ invoiceData.nograbaiva.toFixed(2) }} </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">I.V.A.</vs-th>
                        <vs-td>{{ invoiceData.iva.toFixed(2) }} </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">TOTAL</vs-th>
                        <vs-td>{{ invoiceData.total.toFixed(2) }} </vs-td>
                    </vs-tr>
                </vs-table>
            </div>

        </vx-card>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default{
  data () {
    return {
      mailTo: '',
      recipientDetails: {
        fullName: '',
        rucced: '',
        addressLine1: '',
        mailId: ''
      },
      invoiceDetails: {
        invoiceNo: '',
        invoiceDate: ''
      },
      invoiceData: {
        tasks: [],
        subtotal: 0,
        totalneto:0,
        descuento: 0,
        grabaiva:0,
        nograbaiva:0,
        iva:0,
        total: 0
      }
    }
  },
  computed: {
...mapState('eCommerce',['clientState']),
  },
  methods: {
    printInvoice () {
      window.print()
    }
  },
  components: {},
  mounted () {
    this.$emit('setAppClasses', 'invoice-page')
  },
  created () {
    var pedido = this.$route.params.ped;
    var cliente = this.clientState;
    if(pedido && cliente){
      this.recipientDetails.fullName = pedido.nomcli;
      this.recipientDetails.rucced = pedido.rucced;
      this.recipientDetails.addressLine1 = cliente.dircli;
      this.invoiceDetails.invoiceNo = pedido.numtra;
      this.invoiceDetails.invoiceDate = pedido.fecfac.split(' ')[0];
      this.invoiceData.subtotal = pedido.subtot;
      this.invoiceData.totalneto = pedido.totnet;
      this.invoiceData.descuento = pedido.totdes;
      this.invoiceData.grabaiva = pedido.basea;
      this.invoiceData.nograbaiva = pedido.excen;
      this.invoiceData.iva = pedido.totiva;
      this.invoiceData.total = pedido.totfac;
      this.invoiceData.tasks = pedido.renglones
    }else{
      this.$router.push({name: 'ecommerce-history'})
    }
    
    
  },
}
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }


    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

   .vs-table--not-data {
    padding: 10px;
    text-align: center;
    visibility: hidden !important;
}

@page {
  size: auto;
}
</style>
